<template>
    <v-layout class="map-container" fill-height v-resize="resizeMap">       
        <map-control :uiid="map_uiid" />
        <simulation-map :uiid="map_uiid" ref="map" v-if="!hideMap" >
          <slot></slot>
        </simulation-map>                   
    </v-layout> 
</template>
<script setup lang="ts">
  import { ref, computed, watch, onMounted } from 'vue'
  import SimulationMap from '@/components/map/SimulationMap.vue'
  import { SimulationUiState, buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
  import MapControl from '@/components/map/MapControl.vue'
  import { MapUiState } from '@/models/ui/MapUiState'
  import store from '@/store'

  const props = defineProps<{
    uiid: string
  }>()

  const map = ref()
  
  const hideMap = computed(() => store.myGetters.hideMap)
  const missionGlobal = computed(() => store.myGetters.modifiedAdmMissionGlobal)
  
  const map_uiid = computed(() => buildSimulationUIStateId(missionGlobal.value.MIG_ID!, "map"))
  const simulation_uiid = computed(() => buildSimulationUIStateId(missionGlobal.value.MIG_ID!, "detail"))
  
  const simulationState = computed(() => {
    // retourne un SimulationUiState
    return store.myGetters.uistatebyuiid(simulation_uiid.value) as SimulationUiState
  })

  const leftPanelWidth = computed(() => simulationState.value.leftPanelWidth)

  // Watch for leftPanelWidth changes
  watch(leftPanelWidth, (newValue: string) => {
    if (map.value) {
      map.value.updateSize()
    }
  })

  // Watch for map_uiid changes
  watch(map_uiid, (newValue: string) => {
    store.myActions.UI_ENSURE_MAP_STATE(newValue)
  })

  // Created lifecycle - ensure map state
  store.myActions.UI_ENSURE_MAP_STATE(map_uiid.value)

  onMounted(() => {
    setTimeout(() => resizeMap(), 2000)
  })

  function resizeMap() {
    // console.log("resizeMap")
    if (map.value) {
      map.value.updateSize()
    }
  }
</script> 

<style scoped>
  .btnClose{
    position: sticky;
    top:0px;
    right:0px;
    background: #ddd;
  }
  .data{
    color:  var(--primary-color);
    padding: 0 10px;
  }
  .toggle-left,.toggle-right {
    left:0px;
    margin: 0px;
    padding: 0px;     
    max-width: 100%;
    position:relative;
  }

  .transition{
    transition: all 250ms ease;
  }

  .mission-page{
    background-color:#ddd;
    display:flex;
    flex-direction:column;
    flex-grow:1
  }

  .mission-infos {
    background-color:#f4f4f4;
  }

  .mission-resume{
    
    white-space: nowrap;
    overflow-x: auto;
  }

</style>